import { __module as e } from "../../../_virtual/isNumeric.js";
import { a as t } from "./util/assertString.js";
import "./alpha.js";
import { __exports as r } from "../../../_virtual/alpha.js";
Object.defineProperty(a = e.exports, "__esModule", {
  value: !0
}), a.default = function (e, t) {
  return ((0, o.default)(e), t && t.no_symbols) ? s.test(e) : new RegExp("^[+-]?([0-9]*[".concat((t || {}).locale ? r.decimal[t.locale] : ".", "])?[0-9]+$")).test(e);
}, o = t && t.__esModule ? t : {
  default: t
}, s = /^[0-9]+$/, e.exports = a.default, e.exports.default = a.default;
var a,
  o,
  s,
  l = e.exports;
export { l as i };